import React, { useEffect, useState } from 'react';
import { createContext } from 'react';


const NavigationContext = createContext();

function NavigationProvider({ children }) {
    
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    function handler(){
        setCurrentPath(window.location.pathname);
    }
    const arr=['./carousel_img/img3.jpg','./carousel_img/img4.jpg','./carousel_img/img5.jpg','./carousel_img/img6.jpg','./carousel_img/img7.jpg'];
    const[currentState,setCurrentState]=useState(0);

    useEffect(()=>{
        // setInterval(()=>{
        //     console.log(currentState);
            

        window.addEventListener('popstate', handler);
        return window.removeEventListener('popstate', handler);
    }, []);
    useEffect(()=>{
        setInterval(()=>{setCurrentState(currentState=>currentState<arr.length-1 ? currentState+1: 0);
            console.log('after', currentState);
        },5000);

    },[])
    function navigate(to){
        window.history.pushState({}, '', to);
        setCurrentPath(to);
    }
    
    // const arr = []; 
    // state
    // ./img/img_name.png
    const bgImageStyle={
        backgroundImage: `url(${arr[currentState]})`,
        height: '100%',
        

    }
    
    return <NavigationContext.Provider  value = {{currentPath, navigate}} >
        {currentPath === '/' &&<section style={bgImageStyle} className='header'>
            <div>
            {children}
            <button class="carousel-button carousel-button-left" onClick={()=>{
                if(currentState>0)
                setCurrentState(currentState-1)
                else{
                    setCurrentState(arr.length-1);
                }
            }}>
                &#8249;
            </button>
            <button class="carousel-button carousel-button-right" onClick={()=>{
                if(currentState<arr.length-1)
                setCurrentState(currentState+1)
                else{
                    setCurrentState(0);
                }
            }}>
               &#8250;
            </button>
            </div>
        </section>}
        {currentPath !== '/' && <>{children}</>}
    </NavigationContext.Provider>

}


export { NavigationProvider };

export default NavigationContext;